import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { createElement } from 'react';
import styled from 'styled-components';
import { spacing1x } from '../../styles/spacing.js';
import { CheckboxGroupItem } from './CheckboxGroupItem.js';
import { createCheckboxStatesHashMap, createCheckedValuesArrayFromStates } from './utils.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["value"];
var Container = styled.div.withConfig({
  displayName: "CheckboxGroup__Container",
  componentId: "sc-1y4aj7w-0"
})(["&&{display:flex;flex-direction:column;}&& > div:not(:first-of-type){margin-block-start:calc(", " / 2);}"], spacing1x);
var CheckboxGroup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$ariaLabel;
  var initialValue = props.initialValue,
    items = props.items,
    onChange = props.onChange,
    value = props.value;
  var checkedValues = initialValue || [];
  var checkboxItemValues = React.useMemo(function () {
    return items.map(function (checkboxItem) {
      return checkboxItem.value;
    });
  }, [items]);
  var _React$useState = React.useState(createCheckboxStatesHashMap(checkedValues, checkboxItemValues)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    checkboxStatesHashMap = _React$useState2[0],
    setCheckboxStatesHashMap = _React$useState2[1];
  React.useEffect(function () {
    if (Array.isArray(value)) {
      setCheckboxStatesHashMap(createCheckboxStatesHashMap(value, checkboxItemValues));
    }
  }, [value, checkboxItemValues]);
  var onCheckboxChange = function onCheckboxChange(checkboxValue, checked) {
    var checkedStatesCopy = _objectSpread({}, checkboxStatesHashMap);
    checkedStatesCopy[checkboxValue] = checked;
    setCheckboxStatesHashMap(checkedStatesCopy);
    if (onChange) {
      onChange(createCheckedValuesArrayFromStates(checkedStatesCopy));
    }
  };
  return /*#__PURE__*/jsx(Container, {
    "aria-label": (_props$ariaLabel = props["aria-label"]) !== null && _props$ariaLabel !== void 0 ? _props$ariaLabel : "Checkbox Group",
    ref: ref,
    tabIndex: 0,
    children: items.map(function (_ref) {
      var checkboxItemValue = _ref.value,
        checkboxItemPropsRest = _objectWithoutProperties(_ref, _excluded);
      return /*#__PURE__*/createElement(CheckboxGroupItem, _objectSpread(_objectSpread({}, checkboxItemPropsRest), {}, {
        key: checkboxItemValue,
        value: checkboxItemValue,
        checked: checkboxStatesHashMap[checkboxItemValue],
        onChange: function onChange(e) {
          return onCheckboxChange(checkboxItemValue, e.target.checked);
        }
      }));
    })
  });
});
CheckboxGroup.displayName = "CheckboxGroup";

export { CheckboxGroup };
